import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class DigitalAssetClearingAddress extends RestResource {
  accountNumber = ""
  address = ""
  asset = ""
  memo: string | undefined
}

export const DIGITAL_ASSET_CLEARING_ADDRESS_DESER: SchemaDeSer<DigitalAssetClearingAddress> =
  new SchemaDeSerBuilder(DigitalAssetClearingAddress)
    .ofString("accountNumber")
    .ofString("address")
    .ofString("asset")
    .ofString("memo")
    .toDeSer()
